import LOGO from "../images/Potras.png";

export const Team__Potras = {
  name: "Potras",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#D4A017",
  teamJerseyColor: "#111111",

  // Stats
  gamesWon: 1,
  gamesLost: 3,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 29 + 29 + 16 + 20,
  goalsScoredAgainst: 40 + 54 + 40 + 18,
  defaultGoals: 0,

  dontShowPointDif: true,
  isChampion: false,
  isEliminated: false,

  players: [],
};
